import React, { useEffect, useState } from "react";

import { Route, Redirect } from "react-router-dom";

// components
import Unauthorized from "shared-components/logout/Unauthorized";

// state
import { connect } from "react-redux";

// utils
import { userTypeHasAccess } from "utils/accessControl";
import { getUserRole, isWebsiteUnderMaintenance } from "utils/common";

const AuthGuard = ({ component: Component, authed, type, ld, ...rest }) => {
  const { isUser } = ld.login;
  const userRole = getUserRole();
  const hasAccess = userTypeHasAccess(rest.computedMatch.path);

  const [underMaintenance, setUnderMaintenance] = useState(false);

  useEffect(() => {
    isWebsiteUnderMaintenance().then((res) => setUnderMaintenance(res));
  }, []);

  if (authed === undefined || authed === null) {
    authed = isUser;
  }

  if (type === undefined || type === null) {
    type = userRole;
  }
  
  return (
    <Route
      {...rest}
      render={(props) => {
        if (underMaintenance) {
          return <hfn-Maintenance-web />;
        }
        if (authed) {
          if (userRole === undefined) {
            return (
              <Redirect
                to={{ pathname: "/register", state: { from: props.location } }}
              />
            );
          }
          return hasAccess ? <Component {...props} /> : <Unauthorized />;
        }
        return (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        );
      }}
    />
  );
};

// export default Login
const mapStateToProps = (state) => ({
  ld: state.loginDetails,
  ad: state.appDetails,
});

export default connect(mapStateToProps)(AuthGuard);
